import React from "react";
import { Button, Image, Spinner } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import verificationImage from "../../../assets/images/verificationEmail.png";
import "./VerificationEmail.scss";
import {
  useAuthState,
  useSendEmailVerification,
} from "react-firebase-hooks/auth";
import auth from "../../../init.firebase";
import { toast } from "react-toastify";

const VerificationEmail = () => {
  const [sendEmailVerification, sending, error] =
    useSendEmailVerification(auth);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  // resend email
  const handleResendEmail = async () => {
    try {
      if (user?.email) {
        await sendEmailVerification();
        toast.success("Email has been sent, check your mail");
      }
    } catch (error) {}
  };

  let verificationError = "";

  if (error) {
    verificationError = error?.message;
  }

  //handle navigate
  const handleNavigate = () => {
    navigate("/account/login");
  };

  return (
    <div>
      <h1 className="text-center ">Verify Your Email</h1>
      <h4 className="text-center px-2 ">
        Check your email/spam &amp; Click the link to activate your account.
      </h4>
      <div className="d-flex justify-content-center align-items-center my-4">
        <Image
          className="verification_image"
          fluid
          src={verificationImage}
        ></Image>
      </div>
      {error && <p className="text-danger font-bold">{verificationError}</p>}
      <div className="d-flex justify-content-center align-items-center gap-2">
        <Button
          variant="dark"
          onClick={handleResendEmail}
          style={{ width: "9.375rem" }}
        >
          {sending ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            "Resend Email"
          )}
        </Button>
        <Button variant="dark" onClick={handleNavigate}>
          Enter New Email
        </Button>
      </div>
    </div>
  );
};

export default VerificationEmail;
